import React from 'react';
import styles from './Application.module.css';

export default function MyApplicationsCard({ application, onWithdraw, onContactClick }) {
  const position = application?.position;
  const professor = position?.professor;
  

  const getStatusColor = (status) => {
    switch (status) {
      case 'accepted': return '#22c55e';
      case 'rejected': return '#ef4444';
      default: return '#f59e0b';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'accepted': return '✅';
      case 'rejected': return '❌';
      default: return '⏳';
    }
  };

  const getStatusDisplay = (status) => {
    switch (status) {
      case 'accepted': return 'MOVED FORWARD';
      case 'rejected': return 'REJECTED';
      default: return 'PENDING';
    }
  };

  const canWithdraw = application?.status === 'pending';

  if (!application || !position) {
    return <div>Loading application...</div>;
  }

  return (
    <div className={styles.myApplicationCard}>
      {/* Header */}
      <div className={styles.myApplicationHeader}>
        <div className={styles.positionInfo}>
          <h3 className={styles.positionTitle}>{position.title || 'Unknown Position'}</h3>
          <div className={styles.applicationStatus}>
            <span
              className={styles.statusBadge}
              style={{ backgroundColor: getStatusColor(application.status) }}
            >
              {getStatusIcon(application.status)} {getStatusDisplay(application.status)}
            </span>
          </div>
          <p className={styles.positionInstitution}>{position.institution || 'Unknown Institution'}</p>
          {position.city && position.country && (
            <p className={styles.positionLocation}>{position.city}, {position.country}</p>
          )}
        </div>
      </div>

      {/* Professor Info */}
      {professor && (
        <div className={styles.professorInfo}>
          <p className={styles.professorName}>
            <strong>Professor:</strong> {professor.name || 'Unknown Professor'}
          </p>
          {professor.institution && (
            <p className={styles.professorInstitution}>{professor.institution}</p>
          )}
        </div>
      )}

      {/* Application Details */}
      <div className={styles.applicationDetails}>
        <p className={styles.applicationDate}>
          <strong>Applied:</strong> {application.appliedAt ? new Date(application.appliedAt).toLocaleDateString() : 'Unknown date'}
        </p>
        {application.coverLetter && (
          <div className={styles.coverLetterPreview}>
            <p className={styles.coverLetterLabel}><strong>Cover Letter:</strong></p>
            <p className={styles.coverLetterText}>
              {application.coverLetter.length > 150
                ? `${application.coverLetter.substring(0, 150)}...`
                : application.coverLetter
              }
            </p>
          </div>
        )}
      </div>

      {/* Actions */}
      <div className={styles.myApplicationActions}>
        <button
          className={`${styles.actionBtn} ${styles.contactBtn}`}
          onClick={() => onContactClick(professor)}
          disabled={!professor}
        >
          Contact Professor
        </button>
        
        {canWithdraw && (
          <button
            className={`${styles.actionBtn} ${styles.withdrawBtn}`}
            onClick={() => onWithdraw(application._id)}
          >
            Withdraw
          </button>
        )}
      </div>
    </div>
  );
}